<template>
  <v-expansion-panels v-if="audits?.length > 0">
    <v-expansion-panel v-for="item in audits" :key="item.id">
      <v-expansion-panel-header>
        <v-row>
          <v-col cols="4">
            <v-icon small class="mr-2">
              $freshvueaudits-action-{{ item.event }}
            </v-icon>
            <span>
              {{ item?.auditable?.__typename | auditTypename }}
              {{ item.event | auditEvent }}
            </span>
          </v-col>
          <v-col cols="4" class="text--secondary">
            {{ item.created_at | dateAndTime }}
          </v-col>
          <v-col cols="4" class="text--secondary">
            {{ item?.user?.name || '-' }}
          </v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <audit-changes :audit="item">
          <!-- passthrough slots -->
          <slot v-for="(_, name) in $slots" :slot="name" :name="name" />
          <template
            v-for="(_, name) in $scopedSlots"
            :slot="name"
            slot-scope="slotData"
          >
            <slot :name="name" v-bind="slotData" />
          </template>
        </audit-changes>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import AuditChanges from './AuditChanges'

export default {
  name: 'AuditViewExpansionPanel',

  components: {
    AuditChanges
  },

  props: {
    audits: {
      type: Array,
      required: false,
      default: null
    }
  }
}
</script>
